import PropTypes from 'prop-types';
import { Document, Page } from 'react-pdf';

const PdfView = ({ pdfUrl }) => (
  <Document
    file={{
      url: pdfUrl,
    }}
  >
    <Page pageNumber={1} height={400} width={300} />
  </Document>
);

PdfView.propTypes = {
  pdfUrl: PropTypes.string.isRequired,
};

export default PdfView;
